const errorNameRule = (errorName) => {
  return ({ name }) => name === errorName;
};

const errorMessageRule = (errorMessage) => {
  return ({ message }) => message === errorMessage;
};

const jwtExpiredRuleSet = Object.freeze([
  errorNameRule('NotAuthenticated'),
  errorMessageRule('jwt expired'),
]);

const noAccessTokenRuleSet = Object.freeze([
  errorNameRule('NotAuthenticated'),
  errorMessageRule('No accessToken found in storage'),
]);

const skipErrorMatchers = Object.freeze([jwtExpiredRuleSet, noAccessTokenRuleSet]);

export function beforeSend(event, hint) {
  const { originalException } = hint;

  const skipSending =
    originalException &&
    skipErrorMatchers.some((ruleSet) => {
      return ruleSet.every((rule) => rule(originalException));
    });

  // Returning null will instruct Sentry to discard the exception
  if (skipSending) return null;

  return event;
}

export const ignoreErrors = Object.freeze(['ResizeObserver loop limit exceeded']);
